<template>
  <div>
    <div class="indicator">
      <div class="d-flex justify-space-between align-center">
        <div>
          <span>
            {{ $t(`message.common.${indicator.name}`) }}
          </span>
          <template v-if="indicator.info">
            <v-tooltip bottom :max-width="tooltipMaxWidth">
              <template v-slot:activator="{ on }">
                <v-icon small color="primary" v-on="on">
                  mdi-information-outline
                </v-icon>
              </template>
              <span>{{ indicator.info }}</span>
            </v-tooltip>
          </template>
        </div>
        <span :class="`${indicator.type}--text indicator-value`">
          {{ indicator.value }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExpansionPanelIndicator",
  props: {
    indicator: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      show: false,
      tooltipMaxWidth: 500
    };
  }
};
</script>

<style lang="scss" scoped>
.indicator {
  padding: 16px 0;
  border-bottom: 1px solid rgba($gray-light, 0.3);
}
.indicator-value {
  text-align: right;
}
</style>
